export const SET_PLANNINGDATA = 'SET_PLANNINGDATA';
export const SET_PLANNINGDATE = 'SET_PLANNINGDATE';
export const SET_CREATEEDITDRAWEROPEN = 'SET_CREATEEDITDRAWEROPEN';

